import { Component, OnInit, OnDestroy, HostListener, ElementRef, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";

import {
  CSPSubscriptions,
  GetCSPSubscription,
  GetCSPSubscriptionActions,
  CSPDetailsItemViewModel,
  CSPModifySubscriptionViewModel,
  CSPModifySubscriptionResponse,
  CSPUsageDetailsViewModel,
  KASPChildSKUModel,
} from "../../../../models/csp.model";
import { Subject, Observable, Subscription } from "rxjs";
import { CommonService } from "../../../../services";
import { ActivatedRoute, Router } from "@angular/router";
import { SubscriptionApiResponse } from "../../../../models/api-response.model";
import { ADKDetailsViewModel } from "../../../../models/adk-details-view.model";

import { MatDialog } from "@angular/material/dialog";
import { ConfirmKaspSubscritptionsComponent } from "../../../../popup-collection/confirm-kasp-subscritptions/confirm-kasp-subscritptions.component";
import { CustomerPaymentsOutput } from "../../../../models/account-ledger.model";
import { CheckOutService } from "../../../../services/checkout.service";
import { AnnuityItemsViewModel } from "../../../../models/annuity-view.model";
import { ManageService } from "../../../../services/manage.service";
import { map, skip, takeUntil } from "rxjs/operators";
import { CirrusSubscriptionModel } from "../../../../models/veeam.model";
import { CirrusCancelSubscriptionResponse } from '../../../../models/check-out.model';
import { SimpleMsgPopupComponent } from '../../../../popup-collection/simple-msg/simple-msg-popup.component';


declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-manage-cirrus-details",
  templateUrl: "./manage-cirrus-details.component.html",
  styleUrls: ["./manage-cirrus-details.component.css"],
})


export class ManageCirrusDetailsComponent implements OnInit, OnDestroy {
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;
  cirrusDetails: CirrusSubscriptionModel[] = [];
  agreement: FormGroup;
  tenantId: string;
  prefix: string = "";
  userStatus: string = "";
  poReference: string = "";
  details: ADKDetailsViewModel;
  pendingRowConfirmStatus: boolean = false;
  agreement_validation_messages: any =
    ManageService.agreement_validation_messages;
  subscriptions: CSPSubscriptions[];
  subscriptionsPendingChange: GetCSPSubscription[] = [];
  subscriptionActions: GetCSPSubscriptionActions[];
  subscriptionActionExist: GetCSPSubscriptionActions[];
  annuityItemsPendingList: AnnuityItemsViewModel[] = [];
  addonListPendingList: AnnuityItemsViewModel[] = [];
  confirmSubscriptions: CSPModifySubscriptionViewModel[];
  subscriptionResponse: SubscriptionApiResponse;
  cSPDetailsItemViewModel: CSPDetailsItemViewModel;
  confirmBaseSubscription: CSPModifySubscriptionViewModel;
  confirmAddonSubscription: CSPModifySubscriptionViewModel;
  confirmAnnuityItemSubscription: CSPModifySubscriptionViewModel;
  pendingTotal: number = 0;
  activeTotal: string = "0";
  searchStatusList: string[] = [];
  cspPartnerCenterUsage: CSPUsageDetailsViewModel[] = [];
  finishSubscriptions: CSPModifySubscriptionResponse[];
  totalPriceChange: number = 0;
  togglePriceChange: number = 0;
  originalBaseQty: string[];
  originalAddonQty: string[];
  originalBaseActive: boolean[];
  originalAddonActive: boolean[];
  searchSubscription: string = "";
  mpnIdSelect: string = "";
  mpnIdAddonSelect: string = "";
  mpnList: string[];
  totalPrice: number;
  loadContent: boolean = false;
  isEndUserLoading = false;
  isSubscriptionLoading = false;
  selectedStatus: string[] = [];
  statusList: any = [
    { name: "ACTIVE", value: "active" },
    { name: "PENDING CHANGES", value: "pending" },
    { name: "SUSPEND", value: "suspend" },
  ];
  selectedTabIndex: number = 0;
  changeSubscriptionAmount: number;
  purchase: string;
  isQtyWithinRange = true;
  paymentMethod: CustomerPaymentsOutput = null;
  digitalWalletId: string = "";
  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  subscription: Subscription;

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    if (this.annuityItemsPendingList && this.annuityItemsPendingList.length) {
      return false;
    } else {
      return true;
    }
  }

  constructor(
    private manageService: ManageService,
    private cs: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private checkOutService: CheckOutService
  ) { }

  ngOnInit() {
    this.originalBaseQty = [];
    this.originalAddonQty = [];
    this.originalBaseActive = [];
    this.originalAddonActive = [];
    this.subscriptionActions = [];
    this.changeSubscriptionAmount = this.cs.toNumber(
      this.cs.readCookie("ChangeCirrusSubscriptionAmount")
    );

    $(".activesuspend").removeAttr("checked");

    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (res) => {
        $("#levelOne").animate({ scrollLeft: 250 }, 400);
        this.isQtyWithinRange = true;
      },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      }
    );

    this.activatedRoute.paramMap.pipe(
      map((param) => {
        return param.get("tenantId");
      }),
      skip(1)
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((tenantId) => {
      this.manageService.monitorPendingCirrusSubscriptions([]);
    });
    
    this.activatedRoute.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (param) => {
        this.tenantId = param.get("tenantId");
        this.loadContent = true;
        this.originalBaseQty = [];
        this.originalAddonQty = [];
        this.originalBaseActive = [];
        this.originalAddonActive = [];
        this.subscriptionActions = [];
        this.isEndUserLoading = true;
        this.manageService
          .getADKDetails(this.tenantId, "VDC")
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (value: ADKDetailsViewModel) => {
              this.isEndUserLoading = false;
              this.details = value;
              this.paymentMethod = null;
              this.manageService.monitorCirrusDetailsChange(this.details);              
              if (value.customer && value.customer.out_digital_wallet_id) {
                this.manageService.monitorCurrentPaymentDetails({
                  purchaseAccess: value.puchaseAccess,
                  digitalWalletId: value.customer.out_digital_wallet_id
                });
                this.digitalWalletId = value.customer.out_digital_wallet_id;
                this.checkOutService
                  .GetSubscriptionPaymentMethodList()
                  .subscribe((res) => {
                    if (res) {
                      this.paymentMethod = res.find(
                        (m) =>
                          m.out_customer_number ===
                          this.details.customer.out_digital_wallet_id
                      );
                    }
                  });
              }
            },
            (error: any) => {
              console.info(error);
              this.loadContent = true;
              this.isEndUserLoading = false;
            }
          );

       
        // subscriptions details
        this.isSubscriptionLoading = true;
        this.manageService
          .GetCirrusItemsView(this.tenantId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (res: CSPDetailsItemViewModel) => {
              this.cSPDetailsItemViewModel = res;
              this.purchase = res.purchase;
              this.mpnList = res.mpnList;
              this.subscriptionActions = res.actions;
              this.activeTotal = "0";
              this.subscriptions = this.cSPDetailsItemViewModel.subscriptions;
              let addonTemIndex = -1;
              let totalPrice = 0;
              this.subscriptions.forEach((subscription, baseIndex) => {
                subscription.baseSubscription.editMpnIdValue =
                  subscription.baseSubscription.out_mpnid;
                subscription.baseSubscription.editMpnBool = false;
                subscription.baseSubscription.editDescValue =
                  subscription.baseSubscription.out_sub_description;
                subscription.baseSubscription.editDescBool = false;
                subscription.baseSubscription.originalMpnId =
                  subscription.baseSubscription.out_mpnid;
                subscription.baseSubscription.originalDesc =
                  subscription.baseSubscription.out_sub_description;
                subscription.baseSubscription.out_pendingMessage = "";
                this.originalBaseQty.push(
                  subscription.baseSubscription.out_qty
                );
                subscription.baseSubscription.out_price_number = this.cs.toNumber(
                  subscription.baseSubscription.out_price
                );
                if (subscription.baseSubscription.out_status_desc == "Active") {
                  subscription.baseSubscription.out_activeSuspend = true;
                  this.originalBaseActive.push(
                    subscription.baseSubscription.out_activeSuspend
                  );
                  this.activeTotal = (
                    this.cs.toNumber(this.activeTotal) +
                    this.cs.toNumber(subscription.baseSubscription.out_amount)
                  ).toString();
                } else {
                  subscription.baseSubscription.out_activeSuspend = false;
                  this.originalBaseActive.push(
                    subscription.baseSubscription.out_activeSuspend
                  );
                }
                subscription.addOnSubscription.forEach((addOn, addonIndex) => {
                  addOn.out_pendingMessage = "";
                  addOn.editMpnIdValue = addOn.out_mpnid;
                  addOn.editMpnBool = false;
                  addOn.editDescValue = addOn.out_sub_description;
                  addOn.editDescBool = false;
                  addOn.originalMpnId = addOn.out_mpnid;
                  addOn.originalDesc = addOn.out_sub_description;
                  this.originalAddonQty.push(addOn.out_qty);
                  addOn.out_price_number = this.cs.toNumber(addOn.out_price);
                  if (
                    addOn.out_status_desc == "Active" &&
                    subscription.baseSubscription.out_status_desc == "Active"
                  ) {
                    addOn.out_activeSuspend = true;
                    this.originalAddonActive.push(addOn.out_activeSuspend);
                    this.activeTotal = (
                      this.cs.toNumber(this.activeTotal) +
                      this.cs.toNumber(addOn.out_amount)
                    ).toString();
                  } else {
                    addOn.out_activeSuspend = false;
                    this.originalAddonActive.push(addOn.out_activeSuspend);
                  }
                });
                if (this.subscriptionActions.length) {
                  this.subscriptionActions.forEach((subscriptionAction) => {
                    if (!subscriptionAction.out_error_message) {
                      if (
                        subscriptionAction.out_subscription_id ==
                        subscription.baseSubscription.out_subscription_id
                      ) {
                        subscription.baseSubscription.out_status =
                          subscriptionAction.out_status;
                        subscription.baseSubscription.out_qty = this.cs.toNumber(
                          subscriptionAction.out_qty
                        ).toString();
                        subscription.baseSubscription.out_action_status = true;
                        if (
                          subscriptionAction.out_status_desc == "Active" &&
                          subscriptionAction.out_key != "QTY" &&
                          subscriptionAction.out_key != "REF"
                        ) {
                          subscription.baseSubscription.out_activeSuspend = false;
                          subscription.baseSubscription.out_status = "XX";
                        } else if (
                          subscriptionAction.out_status_desc != "Active" &&
                          subscriptionAction.out_key != "QTY" &&
                          subscriptionAction.out_key != "REF"
                        ) {
                          subscription.baseSubscription.out_activeSuspend = true;
                          if (
                            subscription.baseSubscription.out_activeSuspend ==
                            this.originalBaseActive[baseIndex]
                          ) {
                            subscription.baseSubscription.out_status = "";
                          } else {
                            subscription.baseSubscription.out_status = "PR";
                          }
                        }
                      } else {
                        subscription.baseSubscription.out_action_status = false;
                      }
                    }
                  });
                  subscription.addOnSubscription.forEach(
                    (addOn, addonIndex) => {
                      addonTemIndex++;
                      this.subscriptionActions.forEach((subscriptionAction) => {
                        if (!addOn.out_error_message) {
                          if (
                            subscription.baseSubscription.out_status != "XX" &&
                            subscriptionAction.out_subscription_id !=
                            subscription.baseSubscription.out_subscription_id
                          ) {
                            if (
                              subscriptionAction.out_subscription_id ==
                              addOn.out_subscription_id
                            ) {
                              addOn.out_status = subscriptionAction.out_status;
                              addOn.out_qty = this.cs.toNumber(
                                subscriptionAction.out_qty
                              ).toString();
                              addOn.out_action_status = true;
                              if (
                                subscription.baseSubscription.out_activeSuspend
                              ) {
                                if (
                                  subscriptionAction.out_status_desc ==
                                  "Active" &&
                                  subscriptionAction.out_key != "QTY" &&
                                  subscriptionAction.out_key != "REF"
                                ) {
                                  addOn.out_activeSuspend = false;
                                  addOn.out_status = "XX";
                                } else if (
                                  subscriptionAction.out_status_desc !=
                                  "Active" &&
                                  subscriptionAction.out_key != "QTY" &&
                                  subscriptionAction.out_key != "REF"
                                ) {
                                  addOn.out_activeSuspend = true;
                                  if (
                                    addOn.out_activeSuspend ==
                                    this.originalAddonActive[addonTemIndex]
                                  ) {
                                    addOn.out_status = "";
                                  } else {
                                    addOn.out_status = "PR";
                                  }
                                }
                              } else {
                                addOn.out_activeSuspend = false;
                                addOn.out_status = "XX";
                              }
                            } else {
                              addOn.out_action_status = false;
                            }
                          } else if (
                            subscriptionAction.out_subscription_id ==
                            subscription.baseSubscription
                              .out_subscription_id &&
                            subscription.baseSubscription.out_status == "XX"
                          ) {
                            addOn.out_status_desc = "Pending Base Suspended";
                            addOn.out_activeSuspend = false;
                            $(`#${addOn.out_subscription_id} .statustext`).html(
                              `${addOn.out_status_desc}`
                            );
                          } else if (
                            subscriptionAction.out_subscription_id ==
                            subscription.baseSubscription
                              .out_subscription_id &&
                            subscription.baseSubscription.out_status != "XX"
                          ) {
                            addOn.out_status_desc = "Base Suspended";
                            $(`#${addOn.out_subscription_id} .statustext`).html(
                              `${addOn.out_status_desc}`
                            );
                          } else {
                            addOn.out_activeSuspend = false;
                            addOn.out_status = "XX";
                            addOn.out_status_desc = "Base Suspended";
                            $(`#${addOn.out_subscription_id} .statustext`).html(
                              `${addOn.out_status_desc}`
                            );
                          }
                        }
                      });
                    }
                  );
                } else {
                  subscription.baseSubscription.out_action_status = false;
                  subscription.addOnSubscription.forEach((addOn) => {
                    addOn.out_action_status = false;
                    if (subscription.baseSubscription.out_status == "XX") {
                      addOn.out_status_desc = "Base Suspended";
                      addOn.out_activeSuspend = false;
                      $(`#${addOn.out_subscription_id} .statustext`).html(
                        `${addOn.out_status_desc}`
                      );
                    }
                  });
                }
                this.loadContent = true;
              });

              this.manageService.currentPendingCirrusSubscriptions.subscribe(
                (res: AnnuityItemsViewModel[]) => {
                  if (res && res.length > 0) {
                    this.annuityItemsPendingList = [];
                    this.loadContent = false;
                    res.forEach((result) => {
                      if (result && !result.isExisting) {
                        result.totalPrice =
                          this.cs.toNumber(
                            result.itemPrice.replace("$", "").replace(",", "")
                          ) * this.cs.toNumber(result.quantity);
                        this.annuityItemsPendingList.push(result);
                        this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
                          "",
                          null,
                          0
                        );
                      } else if (result && result.isExisting) {
                        this.subscriptions.forEach((subscription, index) => {
                          if (
                            subscription.baseSubscription.out_stock_code ==
                            result.stockCode
                          ) {
                            subscription.baseSubscription.out_qty = (
                              this.cs.toNumber(
                                subscription.baseSubscription.out_qty
                              ) + this.cs.toNumber(result.quantity)
                            ).toString();
                            this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
                              "base",
                              subscription.baseSubscription,
                              index
                            );
                          }
                          subscription.addOnSubscription.forEach(
                            (addon, addonIndex) => {
                              if (addon.out_stock_code == result.stockCode) {
                                addon.out_qty = (
                                  this.cs.toNumber(addon.out_qty) +
                                  this.cs.toNumber(result.quantity)
                                ).toString();
                                this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
                                  "addon",
                                  addon,
                                  addonIndex
                                );
                              }
                            }
                          );
                        });
                      }
                    });
                    this.annuityItemsPendingList.forEach((element) => {
                      this.manageService
                        .GetKASPChildSKU(
                          element.stockCode,
                          this.cs.toNumber(element.quantity)
                        )
                        .subscribe(
                          (childSku: KASPChildSKUModel) => {
                            if (
                              childSku &&
                              childSku.sku &&
                              childSku.sku.out_current_price
                            ) {
                              element.itemPrice =
                                childSku.sku.out_current_price;
                              element.totalPrice =
                                this.cs.toNumber(element.itemPrice) *
                                this.cs.toNumber(element.quantity);
                            }
                            this.totalPriceChange = this.calculateTotalPriceChange();
                            this.pendingTotal = Math.abs(
                              this.cs.round(this.totalPriceChange, 2) -
                              this.cs.round(this.cs.toNumber(this.activeTotal), 2)
                            );
                            if (!this.pendingTotal) {
                              this.totalPriceChange = 0;
                            }
                          },
                          (error: any) => {
                            console.info(error);
                            this.loadContent = true;
                          }
                        );
                    });
                    this.loadContent = true;
                  } else {
                    this.annuityItemsPendingList = [];
                    this.totalPriceChange = this.calculateTotalPriceChange();
                    this.pendingTotal = Math.abs(
                      this.cs.round(this.totalPriceChange, 2) -
                      this.cs.round(this.cs.toNumber(this.activeTotal), 2)
                    );
                    if (!this.pendingTotal) {
                      this.totalPriceChange = 0;
                    }
                  }
                },
                (error: any) => {
                  console.info(error);
                  this.loadContent = true;
                }
              );
              this.isSubscriptionLoading = false;
              this.cs.applyScrollFixedHeader(this.parentWrapper);
            },
            (error: any) => {
              console.info(error);
              this.loadContent = true;
            }
          );
      },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      }
    );

    this.manageService.currentCirrusTenantDetails.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (value) {
        this.details.customer = value;
      }
    });

    this.manageService.getOrRefreshSubscriptionOrderSubject.asObservable()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value) => {
        this.manageService
          .getADKDetails(this.tenantId, "VDC")
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((value: ADKDetailsViewModel) => {
            this.details = value;
            this.paymentMethod = null;
            if (value.customer.out_digital_wallet_id) {
              this.digitalWalletId = value.customer.out_digital_wallet_id;
              this.checkOutService
                .GetSubscriptionPaymentMethodList()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((res) => {
                  if (res) {
                    this.paymentMethod = res.find(
                      (m) =>
                        m.out_customer_number ===
                        this.details.customer.out_digital_wallet_id
                    );
                  }
                });
            }
          });
      });

    if (
      this.router.url !==
      `/manageSubscriptions/CIRRUS/CirrusDetails/${this.tenantId}`
    ) {
      this.loadContent = true; //set to true to avoid load two loading screen at the same time
    }
  }

  

  private toggleRowConfirmStatus(
    type: string,
    subscription: GetCSPSubscription,
    index: number
  ): boolean {
    let pendingConfirmStatus = false;

    if (type == "base") {
      if (
        subscription.out_qty == this.originalBaseQty[index] &&
        subscription.out_activeSuspend == this.originalBaseActive[index] &&
        subscription.originalDesc == subscription.out_sub_description &&
        subscription.originalMpnId == subscription.out_mpnid
      ) {
        pendingConfirmStatus = false;
      } else {
        pendingConfirmStatus = true;
      }
    } else if (type == "addon") {
      if (
        subscription.out_qty == this.originalAddonQty[index] &&
        subscription.out_activeSuspend == this.originalAddonActive[index] &&
        subscription.originalDesc == subscription.out_sub_description &&
        subscription.originalMpnId == subscription.out_mpnid
      ) {
        pendingConfirmStatus = false;
      } else {
        pendingConfirmStatus = true;
      }
    }

    if (pendingConfirmStatus && subscription) {
      $(`#${subscription.out_subscription_id} .statustext`).html(
        "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
      );
    } else if (!pendingConfirmStatus && subscription) {
      $(
        `#${subscription.out_subscription_id} .pending-pronto-confirmation`
      ).remove();
      $(`#${subscription.out_subscription_id} .statustext`).html(
        `${subscription.out_status_desc}`
      );
    }

    if (
      this.annuityItemsPendingList.length ||
      this.addonListPendingList.length
    ) {
      pendingConfirmStatus = true;
    }

    return pendingConfirmStatus;
  }

  enableAddonEditMpn(subscription: GetCSPSubscription): void {
    subscription.editMpnBool = true;
    subscription.editDescBool = false;
  }

  enablePendingAddonEditMpn(pendingAddOn: AnnuityItemsViewModel): void {
    pendingAddOn.editMPN = true;
  }

  enableAddonEditDesc(subscription: GetCSPSubscription): void {
    subscription.editMpnBool = false;
    subscription.editDescBool = true;
  }

  editAddonMpnId(subscription: GetCSPSubscription, addonIndex: number): void {
    subscription.editMpnBool = false;
    if (subscription.editMpnIdValue) {
      subscription.out_mpnid = subscription.editMpnIdValue;
    } else {
      subscription.editMpnIdValue = subscription.out_mpnid;
    }
    if (this.subscriptionsPendingChange.length) {
      if (!this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id).length) {
        if (subscription.originalMpnId !== subscription.out_mpnid) {
          this.subscriptionsPendingChange.push(subscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
        }
      } else {
        this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id)[0].out_mpnid = subscription.out_mpnid;
      }
    } else {
      if (subscription.originalMpnId !== subscription.out_mpnid) {
        this.subscriptionsPendingChange.push(subscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, addonIndex);
    if (this.pendingRowConfirmStatus) {
      $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else {
      $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
    }
  }


  
  editAddonDesc(subscription: GetCSPSubscription, addonIndex: number): void {
    subscription.editDescBool = false;
    if (subscription.editDescValue) {
      subscription.out_sub_description = subscription.editDescValue;
    } else {
      subscription.editDescValue = subscription.out_sub_description;
    }
    if (this.subscriptionsPendingChange.length) {
      if (!this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id).length) {
        if (subscription.originalDesc !== subscription.out_sub_description) {
          this.subscriptionsPendingChange.push(subscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
        }
      } else {
        this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id === subscription.out_subscription_id)[0].out_sub_description = subscription.out_sub_description;
      }
    } else {
      if (subscription.originalDesc !== subscription.out_sub_description) {
        this.subscriptionsPendingChange.push(subscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(sub => sub.out_subscription_id !== subscription.out_subscription_id);
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('addon', subscription, addonIndex);
    if (this.pendingRowConfirmStatus) {
      $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else {
      $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
    }

  }

  removeAddonPendingItem(subscription: CSPSubscriptions, index: number): void {
    subscription.pendingAddOnSubscription.splice(index, 1);
    this.totalPriceChange = this.calculateTotalPriceChange();
    this.pendingTotal = Math.abs(this.cs.round(this.totalPriceChange, 2) - this.cs.round(this.cs.toNumber(this.activeTotal), 2));
    if (!this.pendingTotal) {
      this.totalPriceChange = 0;
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus('', null, 0);
  }

  editEndUserDetail(event): void {
    event.preventDefault();
    this.manageService.monitorCirrusDetailsChange(this.details);
    this.router.navigate(["EditEndUser"], { relativeTo: this.activatedRoute });
  }

  editPaymentDetails(event): void {
    event.preventDefault();
    this.router.navigate(["EditPaymentDetails"], {
      relativeTo: this.activatedRoute,
    });
  }

  FilterStatus(): void {
    this.searchStatusList = [];
    this.searchStatusList = this.selectedStatus;
  }

  onSelectAll(): void {
    this.selectedStatus = this.statusList.map((x) => x.value);
    this.searchStatusList = this.selectedStatus;
  }

  onClearAll(): void {
    this.selectedStatus = [];
    this.searchStatusList = this.selectedStatus;
  }

  getSubscriptionOrderList(): void {
    this.router.navigate(["AddCirrusSubscriptions"], {
      relativeTo: this.activatedRoute,
    });
  }

  enableEditDesc(subscription: CSPSubscriptions): void {
    subscription.baseSubscription.editMpnBool = false;
    subscription.baseSubscription.editDescBool = true;
  }

  enableEditMpn(subscription: CSPSubscriptions): void {
    subscription.baseSubscription.editMpnBool = true;
    subscription.baseSubscription.editDescBool = false;
  }

  selectMpnId(annuityItem: AnnuityItemsViewModel): void {
    annuityItem.mpn = this.mpnIdSelect;
  }

  editMpnId(subscription: CSPSubscriptions, index: number): void {
    subscription.baseSubscription.editMpnBool = false;
    if (subscription.baseSubscription.editMpnIdValue) {
      subscription.baseSubscription.out_mpnid =
        subscription.baseSubscription.editMpnIdValue;
    } else {
      subscription.baseSubscription.editMpnIdValue =
        subscription.baseSubscription.out_mpnid;
    }
    if (this.subscriptionsPendingChange.length) {
      if (
        !this.subscriptionsPendingChange.filter(
          (sub) =>
            sub.out_subscription_id ==
            subscription.baseSubscription.out_subscription_id
        ).length
      ) {
        if (
          subscription.baseSubscription.originalMpnId !=
          subscription.baseSubscription.out_mpnid
        ) {
          this.subscriptionsPendingChange.push(subscription.baseSubscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(
            (sub) =>
              sub.out_subscription_id !=
              subscription.baseSubscription.out_subscription_id
          );
        }
      } else {
        this.subscriptionsPendingChange.filter(
          (sub) =>
            sub.out_subscription_id ==
            subscription.baseSubscription.out_subscription_id
        )[0].out_mpnid = subscription.baseSubscription.out_mpnid;
      }
    } else {
      if (
        subscription.baseSubscription.originalMpnId !=
        subscription.baseSubscription.out_mpnid
      ) {
        this.subscriptionsPendingChange.push(subscription.baseSubscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(
          (sub) =>
            sub.out_subscription_id !=
            subscription.baseSubscription.out_subscription_id
        );
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
      "base",
      subscription.baseSubscription,
      index
    );
    if (this.pendingRowConfirmStatus) {
      $(
        `#${subscription.baseSubscription.out_subscription_id} .statustext`
      ).html(
        "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
      );
    } else {
      $(
        `#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`
      ).remove();
      $(
        `#${subscription.baseSubscription.out_subscription_id} .statustext`
      ).html(`${subscription.baseSubscription.out_status_desc}`);
    }
  }

  editDesc(subscription: CSPSubscriptions, index: number): void {
    subscription.baseSubscription.editDescBool = false;
    if (subscription.baseSubscription.editDescValue) {
      subscription.baseSubscription.out_sub_description =
        subscription.baseSubscription.editDescValue;
    } else {
      subscription.baseSubscription.editDescValue =
        subscription.baseSubscription.out_sub_description;
    }
    if (this.subscriptionsPendingChange.length) {
      if (
        !this.subscriptionsPendingChange.filter(
          (sub) =>
            sub.out_subscription_id ==
            subscription.baseSubscription.out_subscription_id
        ).length
      ) {
        if (
          subscription.baseSubscription.originalDesc !=
          subscription.baseSubscription.out_sub_description
        ) {
          this.subscriptionsPendingChange.push(subscription.baseSubscription);
        } else {
          this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(
            (sub) =>
              sub.out_subscription_id !=
              subscription.baseSubscription.out_subscription_id
          );
        }
      } else {
        this.subscriptionsPendingChange.filter(
          (sub) =>
            sub.out_subscription_id ==
            subscription.baseSubscription.out_subscription_id
        )[0].out_sub_description =
          subscription.baseSubscription.out_sub_description;
      }
    } else {
      if (
        subscription.baseSubscription.originalDesc !=
        subscription.baseSubscription.out_sub_description
      ) {
        this.subscriptionsPendingChange.push(subscription.baseSubscription);
      } else {
        this.subscriptionsPendingChange = this.subscriptionsPendingChange.filter(
          (sub) =>
            sub.out_subscription_id !=
            subscription.baseSubscription.out_subscription_id
        );
      }
    }
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
      "base",
      subscription.baseSubscription,
      index
    );
    if (this.pendingRowConfirmStatus) {
      $(
        `#${subscription.baseSubscription.out_subscription_id} .statustext`
      ).html(
        "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
      );
    } else {
      $(
        `#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`
      ).remove();
      $(
        `#${subscription.baseSubscription.out_subscription_id} .statustext`
      ).html(`${subscription.baseSubscription.out_status_desc}`);
    }
  }

  getPendingMessage(
    subscription: GetCSPSubscription
  ): GetCSPSubscriptionActions {
    let pendingChange = {} as GetCSPSubscriptionActions;
    pendingChange.out_message = "";
    pendingChange.changeAmount = 0;
    pendingChange.hasChange = false;
    this.subscriptionActions.forEach((subscriptionAction) => {
      if (!subscriptionAction.out_error_message) {
        if (
          subscription.out_subscription_id ==
          subscriptionAction.out_subscription_id
        ) {
          pendingChange.out_status_desc = subscriptionAction.out_status_desc;
          switch (subscriptionAction.out_key) {
            case "CREATE": {
              pendingChange.out_message += "Pending Order Creation ";
              break;
            }
            case "QTY": {
              pendingChange.out_message +=
                "Pending Qty Change to " + subscriptionAction.out_value + " ";
              break;
            }
            case "MPNID": {
              pendingChange.out_message +=
                "Pending MPN ID Change to " +
                subscriptionAction.out_value +
                " ";
              break;
            }
            case "REF": {
              pendingChange.out_message +=
                "Pending Reference Change to " +
                subscriptionAction.out_value +
                " ";
              break;
            }
            case "SUSPEND": {
              pendingChange.out_message += "Pending Suspension ";
              break;
            }
            case "REACTIVATE": {
              pendingChange.out_message += "Pending Reactivation ";
              break;
            }
          }
          pendingChange.changeAmount++;
        }
      } else {
        if (
          subscription.out_subscription_id ==
          subscriptionAction.out_subscription_id
        ) {
          pendingChange.out_status_desc = subscriptionAction.out_status_desc;
          pendingChange.out_message +=
            subscriptionAction.out_error_message + " ";
          pendingChange.changeAmount++;
        }
      }
    });
    return pendingChange;
  }

  showSwitchButton(subscriptionId: string): boolean {
    this.subscriptionActionExist = this.subscriptionActions.filter(
      (subscriptionAction) =>
        subscriptionAction.out_subscription_id == subscriptionId
    );
    if (this.subscriptionActionExist[0]) {
      if (this.subscriptionActionExist[0].out_error_message) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  confirmSubscription(): void {
    const dialogRef = this.dialog.open(ConfirmKaspSubscritptionsComponent, {
      width: "650px",
      data: {
        totalPriceChange: this.totalPriceChange,
        pendingTotal: this.pendingTotal,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.changeSubscriptionAmount = 0;
      this.confirmSubscriptions = [];
      let addonTemIndex = -1;
      this.loadContent = false;
      
    });
  }

  removeAnnuityPendingItem(annuityItemPending: AnnuityItemsViewModel): void {
    this.annuityItemsPendingList = this.annuityItemsPendingList.filter(
      (annuityItem) => annuityItem.stockCode != annuityItemPending.stockCode
    );
    this.manageService.monitorPendingCirrusSubscriptions(
      this.annuityItemsPendingList
    );
    this.pendingRowConfirmStatus = this.toggleRowConfirmStatus("", null, 0);
  }

  toggleBaseActive(
    event: any,
    subscription: CSPSubscriptions,
    index: number
  ): void {
    if (!event.checked) {
      subscription.baseSubscription.out_activeSuspend = false;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
        "base",
        subscription.baseSubscription,
        index
      );
      if (this.pendingRowConfirmStatus) {
        subscription.baseSubscription.out_qty = this.originalBaseQty[index];
        $(
          `#${subscription.baseSubscription.out_subscription_id} .statustext`
        ).html(
          "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
        );
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;
          addon.out_qty = this.originalAddonQty[idx];
          $(`#${addon.out_subscription_id} .statustext`).html(
            "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
          );
        });
      } else {
        $(
          `#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`
        ).remove();
        $(
          `#${subscription.baseSubscription.out_subscription_id} .statustext`
        ).html(`${subscription.baseSubscription.out_status_desc}`);
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;
          addon.out_qty = this.originalAddonQty[idx];
          $(`#${addon.out_subscription_id} .statustext`).html(
            `${subscription.baseSubscription.out_status_desc}`
          );
        });
      }
    } else {
      subscription.baseSubscription.out_activeSuspend = true;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
        "base",
        subscription.baseSubscription,
        index
      );
      if (this.pendingRowConfirmStatus) {
        subscription.baseSubscription.out_qty = this.originalBaseQty[index];
        $(
          `#${subscription.baseSubscription.out_subscription_id} .statustext`
        ).html(
          "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
        );
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = false;
          addon.out_qty = this.originalAddonQty[idx];
          $(`#${addon.out_subscription_id} .statustext`).html(
            "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
          );
        });
      } else {
        $(
          `#${subscription.baseSubscription.out_subscription_id} .pending-pronto-confirmation`
        ).remove();
        $(
          `#${subscription.baseSubscription.out_subscription_id} .statustext`
        ).html(`${subscription.baseSubscription.out_status_desc}`);
        subscription.addOnSubscription.map((addon, idx) => {
          addon.out_activeSuspend = this.originalAddonActive[idx];
          addon.out_qty = this.originalAddonQty[idx];
          $(`#${addon.out_subscription_id} .statustext`).html(
            `${subscription.baseSubscription.out_status_desc}`
          );
        });
      }
    }
    this.totalPriceChange = this.calculateTotalPriceChange();
    this.pendingTotal = Math.abs(
      this.cs.round(this.totalPriceChange, 2) -
      this.cs.round(this.cs.toNumber(this.activeTotal), 2)
    );
    if (!this.pendingTotal) {
      this.totalPriceChange = 0;
    }
  }

  toggleAddonActive(
    event: any,
    subscription: GetCSPSubscription,
    index: number
  ): void {
    if (!event.checked) {
      subscription.out_activeSuspend = false;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
        "addon",
        subscription,
        index
      );
      if (this.pendingRowConfirmStatus) {
        subscription.out_qty = this.originalAddonQty[index];
        $(`#${subscription.out_subscription_id} .statustext`).html(
          "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
        );
      } else {
        $(
          `#${subscription.out_subscription_id} .pending-pronto-confirmation`
        ).remove();
        $(`#${subscription.out_subscription_id} .statustext`).html(
          `${subscription.out_status_desc}`
        );
      }
    } else {
      subscription.out_activeSuspend = true;
      this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
        "addon",
        subscription,
        index
      );
      if (this.pendingRowConfirmStatus) {
        subscription.out_qty = this.originalAddonQty[index];
        $(`#${subscription.out_subscription_id} .statustext`).html(
          "<span class='pending-pronto-confirmation' style='font-weight: bold'>Pending Confirm</span>"
        );
      } else {
        $(
          `#${subscription.out_subscription_id} .pending-pronto-confirmation`
        ).remove();
        $(`#${subscription.out_subscription_id} .statustext`).html(
          `${subscription.out_status_desc}`
        );
      }
    }
    this.totalPriceChange = this.calculateTotalPriceChange();
    this.pendingTotal = Math.abs(
      this.cs.round(this.totalPriceChange, 2) -
      this.cs.round(this.cs.toNumber(this.activeTotal), 2)
    );
    if (!this.pendingTotal) {
      this.totalPriceChange = 0;
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  updateQty(
    type: string,
    subscription: GetCSPSubscription,
    index: number
  ): void {
    this.isQtyWithinRange = true;
    if (!subscription.out_qty) {
      subscription.out_qty = "1";
    }
    // this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(type, subscription, index);
    if (this.cs.toNumber(subscription.out_qty) > 0) {
      if (
        this.cs.toNumber(subscription.out_min_order_qty) >
        this.cs.toNumber(subscription.out_qty)
      ) {
        this.isQtyWithinRange = false;
        if (subscription.out_qty != subscription.out_confirmed_qty) {
          this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
            type,
            subscription,
            index
          );
        }
        // this.commonService.showValidator(`.${index}qty`, "Minimum qty for this item is " + toInteger(subscription.out_min_order_qty.replace(',', '')).toString(), "right", "error");
        this.cs.implementToast(
          "Minimum qty for this item is " +
          this.cs.toInteger(
            subscription.out_min_order_qty.replace(",", "")
          ).toString(),
          "Error"
        );
      } else if (
        this.cs.toNumber(subscription.out_qty) >
        this.cs.toNumber(subscription.out_max_order_qty)
      ) {
        // this.commonService.showValidator(`.${index}qty`, "Maximum qty for this item is " + toInteger(subscription.out_max_order_qty.replace(',', '')).toString(), "right", "error");
        this.isQtyWithinRange = false;
        this.cs.implementToast(
          "Maximum qty for this item is " +
          this.cs.toInteger(
            subscription.out_max_order_qty.replace(",", "")
          ).toString(),
          "Error"
        );
        if (subscription.out_qty != subscription.out_confirmed_qty) {
          this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
            type,
            subscription,
            index
          );
        }
      } else {
        this.pendingRowConfirmStatus = this.toggleRowConfirmStatus(
          type,
          subscription,
          index
        );
        this.isQtyWithinRange = true;
      }
    } else {
      // this.commonService.showValidator(`.${index}qty`, "Qty must be greater than 0", "right", "error");
      this.isQtyWithinRange = false;
      this.cs.implementToast("Qty must be greater than 0", "Error");
      subscription.out_qty = "1";
    }
    this.manageService
      .GetKASPChildSKU(
        subscription.out_stock_code,
        this.cs.toNumber(subscription.out_qty)
      )
      .subscribe(
        (res: KASPChildSKUModel) => {
          if (res && res.sku && res.sku.out_current_price) {
            subscription.out_price = res.sku.out_current_price;
          }
          this.totalPriceChange = this.calculateTotalPriceChange();
          this.pendingTotal = Math.abs(
            this.cs.round(this.totalPriceChange, 2) -
            this.cs.round(this.cs.toNumber(this.activeTotal), 2)
          );
          if (!this.pendingTotal) {
            this.totalPriceChange = 0;
          }
        },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        }
      );
  }

  close() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
    $("#levelOne").animate({ scrollLeft: 0 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private calculateTotalPriceChange(): number {
    let totalPriceChange = 0;
    this.subscriptions.forEach((subscription) => {
      if (
        subscription.baseSubscription.out_status_desc == "Active" &&
        subscription.baseSubscription.out_activeSuspend
      ) {
        totalPriceChange +=
          this.cs.toNumber(subscription.baseSubscription.out_qty) *
          this.cs.toNumber(subscription.baseSubscription.out_price);
      }
      subscription.addOnSubscription.forEach((addOn) => {
        if (addOn.out_status_desc == "Active" && addOn.out_activeSuspend) {
          totalPriceChange +=
            this.cs.toNumber(addOn.out_qty) * this.cs.toNumber(addOn.out_price);
        }
      });
    });

    this.annuityItemsPendingList.forEach((subscription) => {
      totalPriceChange +=
        this.cs.toNumber(subscription.quantity) *
        this.cs.toNumber(subscription.itemPrice.replace("$", ""));
    });
    return totalPriceChange;
  }

  addBackupSubscription(): void {
    
    this.cirrusDetails.push ({
      tenantId: this.tenantId,
      mpnId: "",
      subscriptionId: "",
      CompanyName: this.details.customer.out_company_name,
      AttentionRef: this.details.customer.out_first_name + ' ' + this.details.customer.out_last_name,
      Email: this.details.customer.out_email,
      AddressLine1: this.details.customer.out_address_1,
      City: this.details.customer.out_city,
      State: this.details.customer.out_region,
      PostCode: this.details.customer.out_post_code,
      PhoneNumber:this.details.customer.out_phone
    });
    this.manageService.createCirrusSubscription(this.cirrusDetails).subscribe((res: CSPModifySubscriptionResponse[]) => {
          if (res) {
            this.isSubscriptionLoading = true;
             this.manageService
          .GetCirrusItemsView(this.tenantId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (res1: CSPDetailsItemViewModel) => {
              this.cSPDetailsItemViewModel = res1;
              this.subscriptions = this.cSPDetailsItemViewModel.subscriptions;
          })}
        
        },
          (error: any) => {
            console.info(error);
            this.loadContent = true;
          });
  }

  cancelSubscription(): void {
    
    this.dialog.open(SimpleMsgPopupComponent, {
      width: '350px',
      data: {
        //showCancel: true,
        title: 'Cancel Subscription',
        msg: 'Are you sure you want to cancel this subscription?',
        buttonName: 'Confirm'
      }
    }).afterClosed().subscribe((res) => {
      if (res) {
         this.cirrusDetails.push ({
            tenantId: this.tenantId,
            stockCode: this.cSPDetailsItemViewModel.subscriptions[0].baseSubscription.out_stock_code,
            subscriptionId: this.cSPDetailsItemViewModel.subscriptions[0].baseSubscription.out_subscription_id,
          });
          
          //this.manageService.cancelCirrusSubscription(this.cSPDetailsItemViewModel.subscriptions[0].baseSubscription.out_subscription_id).subscribe((res: CSPModifySubscriptionResponse[]) => {
          this.manageService.cancelCirrusSubscription(this.cirrusDetails[0]).subscribe((res: CirrusCancelSubscriptionResponse) => {
            if (res.resultStatus == 'Success') {
                  this.isSubscriptionLoading = true;
                  this.cs.implementToast("Subscription Cancelled Successfully", "Success");
                    this.manageService.getOrRefreshSubscriptionOrderSubject.next();
                    this.close();
                //    this.manageService
                // .GetCirrusItemsView(this.tenantId)
                // .pipe(takeUntil(this.ngUnsubscribe))
                // .subscribe(
                //   (res1: CSPDetailsItemViewModel) => {
                //     this.cSPDetailsItemViewModel = res1;
                //     this.subscriptions = this.cSPDetailsItemViewModel.subscriptions;
                //     
                // })
                }
                else{
                  this.cs.implementToast(res.detail, "Error");
                }
              
              },
                (error: any) => {
                  console.info(error);
                  this.loadContent = true;
                });
      }
    });
  }
}


